import { render, staticRenderFns } from "./tableActions.vue?vue&type=template&id=fb10684a&scoped=true&lang=pug&"
import script from "./tableActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./tableActions.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./tableActions.vue?vue&type=style&index=0&id=fb10684a&prod&lang=scss&scoped=true&"
import style1 from "./tableActions.vue?vue&type=style&index=1&id=fb10684a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb10684a",
  null
  
)

export default component.exports